import React from 'react';

import { FluidImage, Hidden, Visible } from '@vp/swan';

import { Image } from '../domain/Image';
import { useResponsiveCloudinaryImage } from '../libs/useResponsiveCloudinaryImage';

import { ZoomedImage } from './zoom/ZoomedImage';

export interface GalleryImageProps {
  image: Image;
  zoomContainerId?: string;
  alt: string;
}

export const GalleryImage: React.FC<GalleryImageProps> = (props) => {
  const { src, srcSet } = useResponsiveCloudinaryImage(props.image.gallery);

  return (
    <>
      <Visible xs sm>
        <FluidImage id="gallery-main" src={src} srcSet={srcSet} alt={props.alt} />
      </Visible>

      <Hidden xs sm>
        {!props.zoomContainerId ? (
          <FluidImage id="gallery-main" src={src} srcSet={srcSet} alt={props.alt} />
        ) : (
          <ZoomedImage
            src={src}
            srcSet={srcSet}
            image={props.image}
            zoomContainerId={props.zoomContainerId!}
            alt={props.alt}
          />
        )}
      </Hidden>
    </>
  );
};
